import { PoweredByPill } from "components/PoweredByPill";
import { useChatWidgetPresence } from "context/ChatWidgetPresenceContext";

/**
 * Fixed "Powered by Clear Health" badge for internal (authenticated) pages.
 * Hidden whenever the page has a chat widget on it, fixed or inline — there the
 * chat widget puts its own "Questions?" pill in this corner, and the two would
 * overlap.
 */
export function PoweredByBadge(): JSX.Element | null {
  const { hasChatWidget } = useChatWidgetPresence();

  if (hasChatWidget) {
    return null;
  }

  return <PoweredByPill />;
}
